import { api_GET, api_POST, api_PUT } from "api/axios.js";

const mapaentrada_api =
{
    getList: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`mapaentrada/List`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getItemFromFicha: function(localId, mapaentradaId){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`mapaentrada/${localId}/${mapaentradaId}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    relatorio: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`mapaentrada/relatorio`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }, 
    post: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`mapaentrada`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },    
    put: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_PUT(`mapaentrada`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default mapaentrada_api
